import { Injectable } from '@angular/core';

@Injectable()
export class RoleService {
  private roles: any = {
    1: {
      role: 'Super Administrator',
      defaultRoute: '/user'
    },
    2: {
      role: 'Administrator',
      defaultRoute: '/jobsheet'
    },
    3: {
      role: 'Employee',
      defaultRoute: '/jobsheet'
    }
  };

  constructor() { }

  getDefaultRoute(role: number): string{
    return this.roles[role].defaultRoute;
  }
}
